import { NgModule } from '@angular/core'
import { GraphqlModule } from './graphql/graphql.module'
import { HubspotAnalyticsModule } from './hubspot/analytics/hubspot-analytics.module'
import { LoadingScreenModule } from './loading-screen/loading-screen.module'
import { AuthenticationModule } from './authentication/authentication.module'
import { ReferralModule } from './referral/referral.module'
import { AnalyticsModule } from './analytics/analytics.module'

@NgModule({
    imports: [],
    exports: [
        GraphqlModule,
        AuthenticationModule,
        HubspotAnalyticsModule,
        LoadingScreenModule,
        AuthenticationModule,
        ReferralModule,
        AnalyticsModule,
    ],
})
export class FrameworkModule {}
